import {
    CREATE_OR_UPDATE_TEST_CASE,
    SAVING_TEST_CASE,
    TEST_CASE_UPDATE_STATUS,
    FETCHING_TEST_CASES,
    RECEIVED_TEST_CASES,
    CLEAR_TEST_CASE_RESULTS,
    CLEAR_TEST_CASE_UPDATE_STATUS
  } from "./types.js";
  
import { JSClient } from "../components/JSClient";

const client = new JSClient();

export const createdOrUpdatedTestCase = testCase => ({
    type: CREATE_OR_UPDATE_TEST_CASE,
    payload: testCase
});

export const updatingTestCase = () => ({
    type: SAVING_TEST_CASE
});

export const testCaseStatusUpdated = () => ({
    type: TEST_CASE_UPDATE_STATUS
});

export const fetchingTestCases = (query) => ({
    type: FETCHING_TEST_CASES,
    payload: query
});

export const receviedTestCases = testCasesList => ({
    type: RECEIVED_TEST_CASES,
    payload: testCasesList
});

export const clearTestCaseStatusUpdated = () => ({
    type: CLEAR_TEST_CASE_UPDATE_STATUS
});

export const clearTestCaseResults = () => ({
    type: CLEAR_TEST_CASE_RESULTS
  });

export const asyncCreateTestCase = testCase => async dispatch => {
    dispatch(updatingTestCase());
    try {
        console.log(testCase);
        const response = await client.postTestCase(testCase);
        console.log(response);
        return dispatch(createdOrUpdatedTestCase(response.data));
    } catch (e) {
        dispatch(testCaseStatusUpdated());
    }
};

export const asyncFetchTestCases = (
    testName,
    testSuite,
    versionId) => async dispatch => {
      const request = {};
      request.testId = testSuite + "-" + testName;
      request.timeStamp = versionId;
      dispatch(fetchingTestCases(request));
      const response = await client.getTestCases(request);
      console.log(response)
      return dispatch(receviedTestCases([response.data]));
    };


// WEBPACK FOOTER //
// ./src/actions/testCaseActions.js